export default __webpack_public_path__ + "static/media/p01 p02.e10c964f.jpg";